import { render, staticRenderFns } from "./DateLabel.vue?vue&type=template&id=1e058150&"
import script from "./DateLabel.vue?vue&type=script&lang=js&"
export * from "./DateLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports